export interface SubMenuItem {
  icon?: string
  title: string
  path?: string
  disabled?: boolean
}

export interface MenuItem {
  icon?: string
  title: string
  path?: string
  disabled?: boolean
  items?: SubMenuItem[]
}

const defaultMenuItems: MenuItem[] = [{
  icon: 'bobcaticon-asset',
  title: 'My Machine',
  path: '/service/mymachine'
}, {
  icon: 'book',
  title: 'Service Library',
  path: '/service/library'
}]

export default defaultMenuItems
